// Ruutulaskenta selaimessa. Sama "slippy map" -ruudukko kuin palvelimella
// (backend/app/geo.py), jotta puhelin voi näyttää ruudut heti ilman verkkoa.
// Palvelin on silti totuuslähde: paikallisesti lasketut ruudut näytetään
// "odottaa tallennusta" -tyylillä, kunnes palvelin on vahvistanut ne.

const EARTH_RADIUS_M = 6371008.8;

/** Ruutu, jossa piste on. Palauttaa tunnisteen muodossa "z/x/y". */
export function tileKey(lat, lon, z) {
  const n = 2 ** z;
  const x = Math.floor(((lon + 180) / 360) * n);
  const latRad = (lat * Math.PI) / 180;
  const y = Math.floor(((1 - Math.asinh(Math.tan(latRad)) / Math.PI) / 2) * n);
  return `${z}/${x}/${y}`;
}

/** Ruudun rajat Leafletin muodossa [[etelä, länsi], [pohjoinen, itä]]. */
export function tileBounds(key) {
  const [z, x, y] = key.split("/").map(Number);
  const n = 2 ** z;
  const lon = (xx) => (xx / n) * 360 - 180;
  const lat = (yy) => (Math.atan(Math.sinh(Math.PI * (1 - (2 * yy) / n))) * 180) / Math.PI;
  return [
    [lat(y + 1), lon(x)],
    [lat(y), lon(x + 1)],
  ];
}

/** Kahden pisteen välinen etäisyys metreinä. */
export function distanceM(lat1, lon1, lat2, lon2) {
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(a));
}

/** Siirtää pistettä metreinä pohjoiseen ja itään (simulaattoria varten). */
export function offsetM(lat, lon, northM, eastM) {
  const mPerDeg = (Math.PI * EARTH_RADIUS_M) / 180;
  return [lat + northM / mPerDeg, lon + eastM / (mPerDeg * Math.cos((lat * Math.PI) / 180))];
}

/** Ruudun tunniste "z/x/y" lukuina. */
export function parseKey(key) {
  const [z, x, y] = key.split("/").map(Number);
  return { z, x, y };
}

/** Neliön rajat Leafletin muodossa. (x0, y0) on neliön vasen yläkulma, n sen sivu ruuduissa. */
export function squareBounds(z, x0, y0, n) {
  const [southWest] = tileBounds(`${z}/${x0}/${y0 + n - 1}`);
  const [, northEast] = tileBounds(`${z}/${x0 + n - 1}/${y0}`);
  return [southWest, northEast];
}

/**
 * Lämpökartan solun sijainti ja koko kuvapisteinä kartan nykyisellä zoomilla.
 * origin on kartan näkymän vasen yläkulma maailman kuvapisteinä (Leafletin
 * getPixelBounds().min). Solun zoom voi olla karkeampi tai tarkempi kuin kartan.
 */
export function cellRect(x, y, cellZoom, mapZoom, origin) {
  const size = 256 * 2 ** (mapZoom - cellZoom);
  return { left: x * size - origin.x, top: y * size - origin.y, size };
}
